import styled from '@emotion/styled';
import { Button } from '@mui/material';
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import NationListPopover from './NationListPopover';
import RedotCircleFlag from "./RedotCircleFlag";
import RpIcon from './RpIcon';

const Wrapper = styled('div')(() => ({
  fontSize: '14px',
  display: 'flex',
  height: '23px',
  alignItems: 'center',
  paddingRight: '15px',
  borderRight: '1px solid #D7CFCF',
  ".number": {
    background: 'transparent',
    padding: 0,
    paddingLeft: '10px',
    fontSize: '15px',
    marginRight: '6px',
  },
  ".MuiSvgIcon-root": {
    marginRight: 15,
  }
}));

export default function NationChooser({onChange, record}) {
  const { countries } = useSelector(state => state.app);

  useEffect(() => {
    // todo: 根据使用场景filter countries
    setNationList(countries);
  }, [countries]);

  useEffect(() => {
    if (record != null) {
      setSelectedNation(record);
    } else {
      // todo: 默认国家规则
      setSelectedNation(countries[0]);
    }
  }, [record]);

  const [nationList, setNationList] = useState([]);
  const [selectedNation, setSelectedNation] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const onBtnClick = function (evt) {
    setAnchorEl(evt.currentTarget);
  };

  const onPopOverClose = function () {
    setAnchorEl(null);
  };

  const onNationChanged = function (val) {
    if (onChange) onChange(val);
  };

  return (
    <React.Fragment>
      <Button variant="text" onClick={onBtnClick}>
        <Wrapper>
          {selectedNation != null ? <>
            <RedotCircleFlag code={selectedNation.code?.toLowerCase()}/>
            <span className="number">{selectedNation.areaCode}</span>
            <RpIcon icon={'arrow-down-simple'} size={18}/>
          </> : <></>}
        </Wrapper>
      </Button>

      <NationListPopover list={nationList} anchorEl={anchorEl} onClose={onPopOverClose} onChange={onNationChanged}/>
    </React.Fragment>
  );
}
